import React from 'react';
import PropTypes from 'prop-types';
import {
    buildSegmentosBarra,
    resolvePosicionPct,
    colorSeveridad,
} from '../../utils/HelpPreinforme';
import preinformeStyles from './preinformeStyles';

/**
 * Barra horizontal segmentada de una métrica: un tramo por segmento del
 * payload, con ancho en porcentaje (buildSegmentosBarra) y coloreado por
 * severidad, más un marcador en la posición del valor (resolvePosicionPct).
 * Solo lectura, sin controles de formulario. Devuelve null cuando no hay
 * segmentos utilizables.
 */
const BarraRangos = ({ segmentos, posicionPct, referencia }) => {
    const classes = preinformeStyles();
    const tramos = buildSegmentosBarra(segmentos);

    if (tramos.length === 0) {
        return null;
    }

    const marcadorPct = resolvePosicionPct(posicionPct);

    return (
        <div
            className={classes.barraContainer}
            role="img"
            aria-label={referencia || 'Barra de rangos de la métrica'}
        >
            {tramos.map((tramo, index) => (
                <div
                    key={`${tramo.etiqueta || 'tramo'}-${index}`}
                    className={classes.tramo}
                    title={tramo.etiqueta}
                    style={{
                        width: `${tramo.anchoPct}%`,
                        backgroundColor: colorSeveridad(tramo.severidad),
                    }}
                />
            ))}
            {marcadorPct !== null && (
                <div
                    className={classes.marcador}
                    style={{ left: `${marcadorPct}%` }}
                />
            )}
        </div>
    );
};

BarraRangos.propTypes = {
    segmentos: PropTypes.array,
    posicionPct: PropTypes.number,
    referencia: PropTypes.string,
};

BarraRangos.defaultProps = {
    segmentos: null,
    posicionPct: null,
    referencia: null,
};

export default BarraRangos;
